import { render, staticRenderFns } from "./historyKPIsList.vue?vue&type=template&id=dd254478"
import script from "./historyKPIsList.vue?vue&type=script&lang=js"
export * from "./historyKPIsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports